var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17.712 17.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M17.056,3.771H15.284V2.886a.886.886,0,1,0-1.771,0v.886H8.2V2.886a.886.886,0,0,0-1.771,0v.886H4.657A2.657,2.657,0,0,0,2,6.428V17.056a2.657,2.657,0,0,0,2.657,2.657h12.4a2.657,2.657,0,0,0,2.657-2.657V6.428a2.657,2.657,0,0,0-2.657-2.657Zm.886,13.284a.886.886,0,0,1-.886.886H4.657a.886.886,0,0,1-.886-.886v-6.2h14.17Zm0-7.971H3.771V6.428a.886.886,0,0,1,.886-.886H6.428v.886a.886.886,0,0,0,1.771,0V5.542h5.314v.886a.886.886,0,1,0,1.771,0V5.542h1.771a.886.886,0,0,1,.886.886Z",
    transform: "translate(-2 -2)",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.09c18a1b0720413e63e9803764ec1c59.svg";
export { ForwardRef as ReactComponent };